export const WidgetLoader = () => {
  return <div>WidgetLoader</div>;
};
